import appHelpers from '@utils/app-urls';
import { memo } from 'react';
const cdnURL = appHelpers.getCDNUrl();

const RewardTierIcon = ({
  rewardTierCode,
  className,
}: {
  rewardTierCode: string;
  className?: string;
}) => {
  const url = `${cdnURL}assets/rewards/badges/${rewardTierCode.toLocaleLowerCase()}.png`;
  return <img src={url} width={30} height={30} className={className} />;
};

export default memo(RewardTierIcon);
